import { z } from 'zod';
const MediaMetadataFieldsSchema = z.object({
    ['Content-Type']: z.string().optional(),
    dateCreated: z.iso.datetime().optional(),
    description: z.string().optional(),
    /** Length of the video in seconds, determined from the MediaConvert duration job. */
    duration: z.number().optional(),
    geoAccuracy: z.number().optional(),
    label: z.string().optional(),
    latitude: z.number().optional(),
    longitude: z.number().optional(),
    phoneModel: z.string().optional(),
    photoTime: z.iso.datetime().optional(),
    recordedDate: z.iso.datetime().optional(),
    videoTime: z.number().optional(),
});
export const MediaMetadataSchema = MediaMetadataFieldsSchema.and(z.record(z.string(), z.any()));
export const PartialMediaMetadataSchema = MediaMetadataFieldsSchema.partial();
